import React, { Fragment, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { useConfig } from 'config/ConfigContext';

import {
  nextAction,
  checkPreviousAction,
} from 'actions/workflow';

import style from './style.scss';

let timerId = null;

const MicroBiltWait = () => {
  const appConfig = useConfig();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workflow = useSelector((state) => state.workflow);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const key = searchParams.get('key');
    timerId = setInterval(() => {
      if (get(workflow, ['data', 'url']).split('?')[0] === '/microbilt/wait') {
        dispatch(checkPreviousAction({
          url: `/workflows/microbilt/${key}/checkin`,
          data: {
            checkStatus: true,
          },
        }));
      } else {
        clearTimeout(timerId);
      }
    }, 5000);

    const sourceData = get(workflow, 'data', null) || get(workflow, 'state.data', null);
    if (!sourceData) {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/microbilt/${key}/checkin`,
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    }
  }, []);

  useEffect(() => {
    if (!workflow.isLoading) {
      const url = get(workflow, ['data', 'url'], '');

      if (url.split('?')[0] !== '/microbilt/wait') {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }

        if (get(workflow, 'data.data.nextAction.path') || get(workflow, 'state.data.nextAction.path')) {
          dispatch(nextAction({
            apiUrl: `${appConfig.apiUrl}/workflows${get(workflow, 'data.data.nextAction.path') || get(workflow, 'state.data.nextAction.path')}`,
            data: {},
          }));
        } else if (get(workflow, 'data.nextAction.path') || get(workflow, 'state.nextAction.path')) {
          dispatch(nextAction({
            apiUrl: `${appConfig.apiUrl}/workflows${get(workflow, 'data.nextAction.path') || get(workflow, 'state.nextAction.path')}`,
            data: {},
          }));
        } else if (get(workflow, 'data.url') || get(workflow, 'state.url')) {
          const dataUrl = get(workflow, 'data.url') || get(workflow, 'state.url');
          const routeUrl = dataUrl.replace(appConfig.hostUrl, '');
          navigate(routeUrl);
        }
      }
    }
  }, [workflow]);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className={style['overlay-container']}>
          <h2 className={style['loading-message']}>Loading your account information. Please wait...</h2>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default MicroBiltWait;
